(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tooltip-button"] && !Shopify.designMode) return;
  try {
    window.tooltipManager = window.tooltipManager || {
    activeButtons: [],
    closeAll: function() {
      this.activeButtons.forEach(function(btn) {
        btn.classList.remove('active');
      });
      this.activeButtons = [];
    }
  };

  (function() {
    function initTooltip() {
      const tooltipBtns = document.querySelectorAll('.custom-tooltip-btn');
      if (!tooltipBtns.length) return;

      tooltipBtns.forEach(function(tooltipBtn) {
        if (tooltipBtn.dataset.tooltipInit) return;
        tooltipBtn.dataset.tooltipInit = 'true';

        tooltipBtn.addEventListener('click', function(e) {
          if (window.innerWidth <= 768) {
            e.preventDefault();
            e.stopPropagation();
            window.tooltipManager.closeAll();
            this.classList.add('active');
            window.tooltipManager.activeButtons.push(this);
            setTimeout(() => {
              const closeTooltip = function(event) {
                if (!tooltipBtn.contains(event.target)) {
                  tooltipBtn.classList.remove('active');
                  window.tooltipManager.activeButtons = window.tooltipManager.activeButtons.filter(function(btn) {
                    return btn !== tooltipBtn;
                  });
                  document.removeEventListener('click', closeTooltip);
                }
              };
              document.addEventListener('click', closeTooltip);
            }, 100);
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTooltip);
    } else {
      initTooltip();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
